import ApiService from '@/services/api.service'

const PharmacyVedorsService = {

    getAll() {          
        const requestData = {
            method: 'get',
            url: "/Vendors",
            headers: {
                
            },
            params: { 
               
            }
        }
        return ApiService.customRequest(requestData);
    },    

    add(data){
        return ApiService.post(`/Vendors`, data);
    },

    update(Id,data){
        return ApiService.put(`/Vendors/${Id}`,data);
    },

    delete(id){
        return ApiService.delete(`/Vendors/${id}`)
    },

    getVendors(parameter){       
        const requestData = {
            method: 'get',
            url: "/Vendors/",       
            params: {  
                IsActive: parameter.IsActive,
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber
            }
        }
        return ApiService.customRequest(requestData);
    },

    Get(Id){     
        return ApiService.get(`/Vendors/${Id}`);
    },
}
  
  export default PharmacyVedorsService;